<template>
  <div v-if="!readonly">
    <div class="row mb-2">
      <div class="col">
        <label for="bathtub-type" class="form-label mb-2">{{ $t('components.product-parameter.bathtub.type') }}</label
        ><br />
        <el-radio-group id="bathtubType" v-model="order.bathtubType" size="large">
          <el-radio-button
            v-for="bathtubType in Object.values(BathtubType)"
            :key="bathtubType"
            :label="bathtubType"
            :value="bathtubType"
            :disabled="readonly"
            @change="$emit('sizeChanged')"
          >
            {{ $t(`enum.bathtubType.${bathtubType}`) }} <br />
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label for="anti-slip" class="form-label mb-2">{{ $t('components.product-parameter.bathtub.antiSlip') }}</label
        ><br />
        <el-switch v-model="order.antiSlip" />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label for="wallpanels" class="form-label mb-2">{{ $t('components.product-parameter.bathtub.wallpanels') }}</label
        ><br />
        <el-switch v-model="order.wallpanels" />
      </div>
    </div>

    <div v-if="order?.wallpanels">
      <div class="row mb-2">
        <div class="col">
          <label for="panel-variant" class="form-label mb-2">{{ $t('components.product-parameter.bathtub.panelVariant') }}</label
          ><br />
          <el-radio-group id="panel-variant" v-model="order.panelVariant" size="large">
            <el-radio-button
              v-for="panelVariant in Object.values(PanelVariant)"
              :key="panelVariant"
              :label="panelVariant"
              :value="panelVariant"
              @change="[$emit('sizeChanged')]"
            >
              {{ $t(`enum.panelVariant.${panelVariant}`) }} <br />
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div v-if="order?.panelVariant == PanelVariant.single" class="row mb-2">
        <div class="col">
          <el-checkbox v-model="order.singleType" style="color: #fff" value="right" label="right" size="large">
            {{ $t('components.product-parameter.bathtub.right') }}</el-checkbox
          >

          <el-checkbox v-model="order.singleType" style="color: #fff" value="left" label="left" size="large">
            {{ $t('components.product-parameter.bathtub.left') }}</el-checkbox
          >

          <el-checkbox v-model="order.singleType" style="color: #fff" value="back" label="back" size="large">
            {{ $t('components.product-parameter.bathtub.back') }}</el-checkbox
          >
        </div>
      </div>

      <div v-if="order?.panelVariant == PanelVariant.combo" class="row mb-2">
        <el-radio-group id="panel-variant" v-model="order.comboType" size="medium">
          <el-radio-button value="right" label="right">{{ $t(`components.product-parameter.bathtub.combo1`) }}</el-radio-button>
          <el-radio-button value="left" label="right">{{ $t(`components.product-parameter.bathtub.combo2`) }}</el-radio-button>
        </el-radio-group>
      </div>

      <div v-if="order?.panelVariant == PanelVariant.complete" class="row mb-2">
        <el-radio-group id="panel-variant" size="medium">
          <el-radio-button>{{ $t(`components.product-parameter.bathtub.complete`) }}</el-radio-button>
        </el-radio-group>
      </div>

      <div
        v-if="(order?.panelVariant == PanelVariant.combo && order?.comboType === 'right') || order?.panelVariant == PanelVariant.complete"
        class="row"
      >
        <div class="col">
          <label for="right-angle-range" class="form-label mb-0">{{
            $t('components.order-form.angle') + ' ' + $t('enum.views.right') + ' (' + $t('components.order-form.degree') + ')'
          }}</label>
          <el-slider
            v-model="order.angleRight"
            show-input
            :precision="0"
            :min="0"
            :max="360"
            :step="1"
            :show-tooltip="false"
            if="right-angle-range"
            :disabled="readonly"
          />
        </div>
      </div>

      <div
        v-if="(order?.panelVariant == PanelVariant.combo && order?.comboType === 'left') || order?.panelVariant == PanelVariant.complete"
        class="row"
      >
        <div class="col">
          <label for="left-angle-range" class="form-label mb-0">{{
            $t('components.order-form.angle') + ' ' + $t('enum.views.left') + ' (' + $t('components.order-form.degree') + ')'
          }}</label>
          <el-slider
            v-model="order.angleLeft"
            show-input
            :precision="0"
            :min="0"
            :max="360"
            :step="1"
            :show-tooltip="false"
            if="left-angle-range"
            :disabled="readonly"
          />
        </div>
      </div>

      <div v-if="order?.panelVariant == PanelVariant.complete" class="row">
        <div class="col">
          <label for="width-range" class="form-label mb-0">{{ $t('components.order-form.panelWidth') }}</label>
          <el-slider
            id="width-range"
            v-model="order.panelWidth"
            show-input
            :precision="0"
            :min="210"
            :max="400"
            :step="10"
            :show-tooltip="false"
            :disabled="readonly"
            @change="$emit('sizeChanged')"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <h3 class="mt-3">{{ $t('components.order-summary.parameterTitle') }}</h3>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.product-parameter.bathtub.type') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ $t(`enum.bathtubType.${order?.bathtubType}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.product-parameter.bathtub.antiSlip') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ $t(`enum.yesNoType.${order?.antiSlip}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.product-parameter.bathtub.wallpanels') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ $t(`enum.yesNoType.${order?.wallpanels}`) }}</label>
    </div>
    <div v-if="order?.wallpanels">
      <div class="row1">
        <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.product-parameter.bathtub.panelVariant') }}</label>
        <label class="col-sm-6 form-label mb-1">{{ $t(`enum.panelVariant.${order?.panelVariant}`) }}</label>
      </div>
      <div class="row1">
        <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.product-parameter.bathtub.description') }}</label>
        <label class="col-sm-6 form-label mb-1">{{ getPanelDescription() }}</label>
      </div>
    </div>
    <div
      v-if="(order?.panelVariant == PanelVariant.combo && order?.comboType === 'right') || order?.panelVariant == PanelVariant.complete"
      class="row1"
    >
      <label class="col-sm-6 form-label text-secondary mb-1">{{
        $t('components.order-form.angle') + ' ' + $t('enum.views.right') + ' (' + $t('components.order-form.degree') + ')'
      }}</label>
      <label class="col-sm-6 form-label mb-1">{{ order?.angleRight }}</label>
    </div>
    <div
      v-if="(order?.panelVariant == PanelVariant.combo && order?.comboType === 'left') || order?.panelVariant == PanelVariant.complete"
      class="row1"
    >
      <label class="col-sm-6 form-label text-secondary mb-1">{{
        $t('components.order-form.angle') + ' ' + $t('enum.views.left') + ' (' + $t('components.order-form.degree') + ')'
      }}</label>
      <label class="col-sm-6 form-label mb-1">{{ order?.angleLeft }}</label>
    </div>
    <div v-if="order?.panelVariant == PanelVariant.complete" class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.order-form.panelWidth') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ order?.panelWidth }}</label>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { Check, Close, Connection } from '@element-plus/icons-vue';
import { shallowRef } from 'vue';

import { BathtubType, PanelVariant } from '@/types/enum/order';
import i18n from '@/i18n';
import { OrderData } from '@/views/ConfiguratorPage.vue';

@Component
export default class ProductParameterBathtub extends Vue {
  @Prop() order!: OrderData;
  @Prop({ default: false }) readonly!: boolean;

  BathtubType = BathtubType;
  PanelVariant = PanelVariant;

  Check = shallowRef(Check);
  Close = shallowRef(Close);
  Connection = shallowRef(Connection);

  getPanelDescription() {
    let panelDescription;

    if (this.order?.panelVariant == 'single') {
      panelDescription = [];

      if (this.order?.singleType.toString().includes('right')) {
        panelDescription.push(i18n.global.t('components.product-parameter.bathtub.right'));
      }
      if (this.order?.singleType.toString().includes('left')) {
        panelDescription.push(i18n.global.t('components.product-parameter.bathtub.left'));
      }
      if (this.order?.singleType.toString().includes('back')) {
        panelDescription.push(i18n.global.t('components.product-parameter.bathtub.back'));
      }
    } else if (this.order?.panelVariant == 'combo') {
      if (this.order?.comboType.toString().includes('right')) {
        panelDescription = i18n.global.t(`components.product-parameter.bathtub.combo1`);
      } else if (this.order?.comboType.toString().includes('left')) {
        panelDescription = i18n.global.t(`components.product-parameter.bathtub.combo2`);
      }
    } else if (this.order?.panelVariant == 'complete') {
      panelDescription = i18n.global.t(`components.product-parameter.bathtub.complete`);
    }

    return panelDescription;
  }
}
</script>

<style scoped lang="scss">
.text-secondary {
  color: #0000008d !important;
  text-align: left !important;
}

.row1 {
  border-bottom: 0.1rem solid #6767678d;
}

.form-label {
  font-size: 1rem;
  margin: 0.7rem 0 0.5rem 0;
  text-align: right;
}

.parameter-img {
  padding-top: 12px;
  width: 100px;
  height: 100px;
}
</style>
